export const Bio = {
  name: "Shahzad Hussain",
  roles: [
    "Full Stack Developer",
    "Software Developer",
    "Website Developer",
    "Freelancer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/shexitech",
  resume:
    "#",
  linkedin: "https://www.linkedin.com/in/shexitech/",
  twitter: "https://twitter.com/",
  insta: "https://www.instagram.com/shexitech/",
  facebook: "https://www.facebook.com/shexitech",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      },
      {
        name: "JQuery",
        image: require("../images/jquery.png"),
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Php",
        image: require('../images/php.png'),
      },
      {
        name: "CodeIgniter",
        image: require('../images/codeigniter.png'),
      },
      {
        name: "Laravel",
        image: require('../images/laravel.png'),
      },
      {
        name: "Graph QL",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "REST API's",
        image: require("../images/restapi.png"),
      },
    ]
  },
  {
    title: "Databases",
    skills: [
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "MariaDB",
        image: require("../images/mariadb.png"),
      }
    ],
  },
  {
    title: 'DevOps',
    skills: [
      {
        name: "Apache",
        image: require("../images/icons/apache-icon.png"),
      },
      {
        name: "NGINX",
        image: require("../images/icons/nginx-icon.png"),
      },
    ]
  },
  {
    title: "Others",
    skills: [
      {
        name: "VS Code",
        image: require("../images/icons/visual-studio-code-icon.png"),
      },
      {
        name: "Git",
        image: require("../images/icons/git-icon.png"),
      },
      {
        name: "GitHub",
        image: require("../images/icons/github-icon.png"),
      },
      {
        name: "Postman",
        image: require("../images/icons/postman-icon.png"),
      },
      {
        name: "Figma",
        image: require("../images/icons/figma-icon.png"),
      },
    ]
  }
];

export const experiences = [
  {
    id: 0,
    img: require("../images/yooshaySoft.png"),
    role: "Senior Software Engineer",
    company: "YooshaySoft Technologies",
    date: "Aug 2019 - Continue",
    dateJoin: 'Aug 2019',
    desc: "Developed Many Systems in Laravel, CodeIgniter and Shopify",
    skills: [
      "HIPPA COMPLIENCE",
      "JavaScript",
      "JQuery",
      "Laravel",
      "MySQL",
      "Firebase",
      "Payment Methods",
      "Shopify Stores",
    ],
  },
  {
    id: 1,
    img: require("../images/bluecascade.png"),
    role: "Web Application Developer",
    company: "Bluecascade PVT LTD",
    date: "December 2018 - July 2019",
    dateJoin: 'December 2018',
    desc: "Developed a solution ",
    skills: [
      "JQuery",
      "Bootstrap",
      "Laravel",
      "Postgre SQL",
      "RESTful API's",
      "Chrome Extensions",
    ],
  },
  {
    id: 2,
    img: require('../images/bluecascade.png'),
    role: "Junior Backend Developer",
    company: "Tasveeq IT Solution",
    date: "Sep 2017 - Nov 2018",
    dateJoin: 'Sep 2018',
    desc: "Worked on many application, One of the major project which made from sctach is 'Umrahcab.com' ",
    skills: [
      "HTML",
      "JQuery",
      "Bootstrap",
      "Condeigniter",
      "MySQL",
      "AJAX",
      "Restful API's",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: require('../images/bzu.png'),
    school: "Bahaudin Zikriya University, Multan",
    date: "Oct 2013 - Aug 2017",
    dateComplete: "Aug 2017",
    grade: "2.98/4.0 CGPA",
    desc: "Acquired proficiency in C++, Java, web technologies, and databases, successfully designed a web-based Patient Management System, created C++ games, and earned third place in a coding and game competition.",
    degree: "Bacholar in Information Technology",
  },
  {
    id: 1,
    img: '',
    school: "Multan Poly technic Institute, Multan",
    date: "Sep 2009 - April 2012",
    dateComplete: "April 2012",
    grade: "A",
    desc: " ",
    degree: "DAE Civil",
  },
];

export const projects = [
  {
    id: 0,
    title: "Shopify Store - Davie Group (The Oodie)",
    date: "Jan 2019 - Continue",
    description:
      "I am responsile to comunicate with internal team members and work on tasks which is assinged by their heigher Managment",
    image: require("../images/projects/theoodie.png"),
    tags: [
      "Shopify Plus",
      "Laravel",
      "CRM",
      "Liquid",
      "Javascript",
      "API Integrations"
    ],
    category: "shopify",
  },
  {
    id: 1,
    title: "Shopify Store - Billionaire Suit",
    date: "Jan 2025 - Continue",
    description:
      "Fimga to Shopify theme. i have convert the Figma to SHopify theme using DAWN theme.",
      image: require("../images/projects/billionaire.png"),
    tags: [
      "JS",
      "JQuery",
      "Bootstrap",
      "Shopify",
      "Figma",
      "Ajax",
      "API's",
      "Klaviyo",
      "APP Integrations",
    ],
    category: "shopify",
  },
  {
    id: 2,
    title: "Shopify Store - Online Beauty Essentials",
    date: "March 2024 - Aug 2024",
    description:
      "Developed a tailored Campus Management System with efficient performance evaluation, customizable roles, a streamlined CMS, and an interactive online assessment platform.",
    image: require("../images/projects/stay-alert.png"),
    tags: [
      "JS",
      "JQuery",
      "Bootstrap",
      "Shopify",
      "MySQL",
      "Ajax",
      "Custom Theme Development",
      "API's",
      "Klaviyo",
      "APP Integrations",
    ],
    category: "shopify",
  },
  {
    id: 3,
    title: "Shopify Store - Aninu",
    date: "Nov 2023 - Jan 204",
    description:
      "Created this store for a client, API integrations for this store.",
      image: require("../images/projects/aninu.png"),
    tags: [
      "JS",
      "JQuery",
      "Bootstrap",
      "Shopify",
      "AJAX",
      "REST API's",
      "PHP",
      "Mysql",
      "Webhook",
    ],
    category: "shopify",
  },
  {
    id: 4,
    title: "Color Blind Test - Testing color vision",
    date: "Aug 2019 - Dec 2022",
    description:
      "Build V2 version for this website, integrate HIPPA complience in this application.",
      image: require("../images/projects/testingcolorvision.png"),
    tags: [
      "JavaScript",
      "JQuery",
      "Google Map API",
      "Bootstrap",
      "Codeigniter",
      "HIPPA Complience",
      "MySQL",
      "AJAX",
    ],
    category: "codeigniter",
  },
  {
    id: 5,
    title: "Booking Website - excelsiorcars",
    date: "Jan 2018 - Nov 2018",
    description:
      "Build the Whole website using Codeigniter, this web application use the google api to find out the best route an calculate fare according to miles.",
      image: require("../images/projects/excel.png"),
    tags: [
      "JavaScript",
      "JQuery",
      "Google Map API",
      "Bootstrap",
      "Codeigniter",
      "MySQL",
      "AJAX",
    ],
    category: "codeigniter",
  },

];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
